import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { metersQueryKey } from '../queries/useMeters'
import type { Meter, MeterReplaceWrite } from '../types'

/** Closes the old meter and creates its successor in one call. */
export function useReplaceMeter() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError()

  async function replaceMeter({
    id,
    body
  }: {
    id: string
    body: MeterReplaceWrite
  }) {
    const response = await apiClient.post<Meter>(
      SNA_PREFIX + `meters/${id}/replace`,
      body
    )
    return response.data
  }

  return useMutation({
    mutationFn: replaceMeter,
    onSuccess: () => {
      toast.success({ message: t('meterReplaced') })
      queryClient.invalidateQueries({ queryKey: metersQueryKey })
    },
    onError
  })
}
